import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, HttpClientModule } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './components/app.component';
import { unauthorizedComponent } from './components/unauthorized/unauthorized.component';

import { HttpClientService } from './http-client.service';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalBroadcastService, MsalInterceptor, MsalModule, MsalService } from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuard } from '@azure/msal-angular';
import { AuthorizationInterceptor } from './http-interceptors/authorization-interceptor';
import { httpInterceptorProviders } from './http-interceptors';

export function getAdalConfig() {
  return {
    tenant: environment.adalConfig.tenant,
    clientId: environment.adalConfig.clientId,
    endpoints: environment.adalConfig.endpoints,
    redirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
    cacheLocation: 'sessionStorage'
  };
}


@NgModule({
  declarations: [
    AppComponent,
    unauthorizedComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    MatSnackBarModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (handler: HttpBackend) => new TranslateHttpLoader(new HttpClient(handler), './assets/i18n/', '.json'),
        deps: [HttpBackend]
      }
    }),
    MsalModule.forRoot(
      new PublicClientApplication({
       auth: {
         clientId:  environment.adalConfig.clientId,
         authority: 'https://login.microsoftonline.com/'+ environment.adalConfig.tenant,
         redirectUri:  window.location.origin

       },
       cache: {
         cacheLocation: "sessionStorage"
     
       },
       
     }),
    
     {
       interactionType: InteractionType.Redirect, // Msal Guard Configuration
       authRequest: {
        scopes: ['user.read'],
       },
     },
     {
       interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
       protectedResourceMap: new Map([
        ["https://graph.microsoft.com/v1.0/me", ["user.read","openid","profile","offline_access"]],

       ]),
     }
   ),
  ],
  

  providers: [
    httpInterceptorProviders,

     { provide: HttpClientService, useFactory: (http: HttpClient, router: Router) => new HttpClientService(http, router), deps: [HttpClient, Router] },
   MsalGuard,MsalService
  ],

  bootstrap: [AppComponent],
  exports: [ CommonModule, FormsModule ]
})
export class AppModule { }
